module.exports = __webpack_public_path__ + "img/EDG.605d5507.svg";